import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  RichMessageCallbackInput,
  RichMessageDialog,
  RichMessageDialogUniqueProps,
} from '../rich-message-dialog';

// Create the hooks inside a function to avoid initialization issues
const createHooks = () => {
  const { useDialogForContext, useDialog: useRichMessageDialog } =
    getDialogHooks<RichMessageDialogUniqueProps, RichMessageCallbackInput>(
      RichMessageDialog
    );
  return { useDialogForContext, useRichMessageDialog };
};

// Defer hook creation until first use to avoid circular dependency issues
let hooksCache: ReturnType<typeof createHooks> | null = null;

const getHooks = () => {
  if (!hooksCache) {
    hooksCache = createHooks();
  }
  return hooksCache;
};

export const useRichMessageDialogForContext = () =>
  getHooks().useDialogForContext();
export default () => getHooks().useRichMessageDialog();
